import PropTypes from 'prop-types'

const Checkbox = ({ children, checked, disabled, onChange, className }) => {
  const classNameCheckbox =
    'checkbox' +
    (checked ? ' checkbox--checked' : '') +
    (className ? ` ${className}` : '')

  return (
    <label className='checkbox-wrapper'>
      <span className={classNameCheckbox}>
        <input
          type='checkbox'
          className='checkbox__input'
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <span className='checkbox__inner' />
      </span>
      <span>{children}</span>
    </label>
  )
}

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Checkbox
